import React, { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import '../../../css/common/ArtistDemoPreview.css';
import DsButton from '../DsButton';
import { resetSocket } from '../../../lib/socket';
import {
  ARTIST_DEMO_ARTIST,
  ARTIST_DEMO_SCENARIOS,
  getArtistDemoState,
  stopArtistDemo,
  subscribeArtistDemo,
} from '../../../utils/artistDemoRuntime';

const ARTIST_DEMO_CHAT_PATH_PREFIXES = [
  '/artist/workspaces/communications/chat',
  '/artist/workspaces/event-operations/event-chat',
];

export function isArtistDemoChatPath(pathname = '') {
  return ARTIST_DEMO_CHAT_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export default function ArtistDemoBanner() {
  const location = useLocation();
  const demo = useSyncExternalStore(subscribeArtistDemo, getArtistDemoState, getArtistDemoState);
  const isChatPath = isArtistDemoChatPath(location.pathname);

  useEffect(() => {
    if (!demo.active || isChatPath) return undefined;
    const previousTitle = document.title;
    document.title = `【プレビューモード】${ARTIST_DEMO_ARTIST.name} | Casticart`;
    document.body.classList.add('artist-demo-preview-mode');
    return () => {
      document.title = previousTitle;
      document.body.classList.remove('artist-demo-preview-mode');
    };
  }, [demo.active, isChatPath]);

  if (!demo.active || isChatPath) return null;

  const scenario = ARTIST_DEMO_SCENARIOS.find((item) => item.id === demo.scenarioId);
  const exitDemo = () => {
    stopArtistDemo();
    resetSocket();
    window.close();
    window.setTimeout(() => {
      if (!window.closed) window.location.assign('/admin/workspaces/system/manuals/artist-demo');
    }, 100);
  };

  return (
    <aside
      className="artist-demo-banner"
      aria-label="アーティスト画面のプレビューモード"
      title="デモデータのみ・基準日 2026年7月1日・操作は保存されません"
    >
      <div className="artist-demo-banner__content">
        <strong className="artist-demo-banner__mode">
          <i className="fa-solid fa-eye" aria-hidden="true" />
          <span className="artist-demo-banner__mode-label">プレビュー</span>
          <span className="artist-demo-banner__mode-label-mobile">デモ表示</span>
          <span className="artist-demo-banner__mode-suffix">モード</span>
        </strong>
        <span className="artist-demo-banner__identity">{ARTIST_DEMO_ARTIST.name}</span>
        <span className="artist-demo-banner__scenario">{scenario?.label || '標準利用中'}</span>
        <small className="artist-demo-banner__notice">
          <i className="fa-solid fa-shield-halved" aria-hidden="true" />
          デモデータのみ・基準日 2026年7月1日・操作は保存されません
        </small>
      </div>
      <DsButton
        variant="secondary"
        size="sm"
        className="artist-demo-banner__close"
        onClick={exitDemo}
        aria-label="プレビューを閉じる"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
        <span>プレビューを閉じる</span>
      </DsButton>
    </aside>
  );
}
